import { useEffect, useRef } from 'react';
import { useBlocker } from 'react-router-dom';
import { useModal } from 'mui-modal-provider';

import { UnsavedChangesConfirmationModal } from '../unsaved-changes-confirmation-modal';
import { ILeavePrompt } from './leave-prompt.models';
import { useScreenState } from '../../../graphql/user/actions/screenBlock';
import { UnsavedChangesModal } from '../unsaved-changes-modal';

export const LeavePrompt = ({ confirmationModalProps }: ILeavePrompt): null => {
  const { setStateToBlocked, setStateToUnblock } = useScreenState();
  const { showModal } = useModal();
  const blocker = useBlocker(true);
  const modalRef = useRef<{ hide: () => void } | null>(null);
  const UnsavedModal = confirmationModalProps ? UnsavedChangesConfirmationModal : UnsavedChangesModal;
  const unsavedProps = confirmationModalProps ? confirmationModalProps : [] as any;

  useEffect(() => {
    setStateToBlocked();
    return () => {
      setStateToUnblock();
    };
  }, []);

  useEffect(() => {
    if (blocker.state !== 'blocked' || modalRef.current) {
      return;
    }

    const { hide } = showModal(UnsavedModal as any, {
      ...unsavedProps,
      onConfirm: () => {
        modalRef.current = null;
        setStateToUnblock();
        blocker.proceed();
        hide();
      },
      onReject: () => {
        modalRef.current = null;
        blocker.reset();
        hide();
      },
    });

    modalRef.current = { hide };
  }, [blocker.state, blocker.proceed, blocker.reset, showModal, UnsavedModal, unsavedProps]);

  return null;
};
